import { useEffect, useState } from 'react';

/**
 * Handles the lazy loading of an avatar source url
 *
 * @param {string} userId user's id
 * @param {() => Promise<string | undefined>} fetchAvatarUrlFn function to call to fetch the avatar url
 * @returns {[string | undefined]} array containing url of the avatar image
 */
export const useLazyLoadAvatarUrl = (
  userId: string,
  fetchAvatarUrlFn?: () => Promise<string | undefined>
) => {
  const [loadedAvatar, setLoadedAvatar] = useState<{
    userId: string;
    url?: string;
  }>();

  useEffect(() => {
    let current = true;
    if (!fetchAvatarUrlFn) {
      setLoadedAvatar({ userId, url: undefined });
      return () => {
        current = false;
      };
    }

    void fetchAvatarUrlFn()
      .then(
        (url) => current && setLoadedAvatar({ userId, url })
      )
      .catch(
        () => current && setLoadedAvatar({ userId, url: undefined })
      );

    return () => {
      current = false;
    };
  }, [userId, fetchAvatarUrlFn]);

  return [loadedAvatar?.userId === userId ? loadedAvatar.url : undefined];
};
